import { defineComponent as _defineComponent } from 'vue'
import AdminNavigation from "../../AdminNavigationContainer.vue";
import { ref, onMounted, onBeforeUnmount, reactive, onUpdated, watch } from "vue";
import { useI18n } from "vue3-i18n";
import ResponseData from "@/types/ResponseData";
import Loading from "@/components/home/Loading.vue";
import Alert from "@/components/scan/parts/Alert.vue";
import { store } from "@/store/store";
import StationDataService from "@/services/StationDataService";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const title = ref("Station Code Maintenance");
const stationCodeListInfo = reactive([]);
const modalStationCode = ref("");
const getData = ref(false);
const isPageLoad = ref(true);

/** 初期表示設定 */
onMounted(function () {
  window.addEventListener('resize', handleResize);
  isLoading.value = true;
  if(store.getters.stationListData != null){
    stationCodeListInfo.splice(0);
    stationCodeListInfo.push(store.getters.stationListData);
    isLoading.value = false;
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

function handleResize() {
  try {
    var tableHeight = 0;
    var dataHeight = document.getElementById("tbltbody")?.clientHeight;
    if (dataHeight != 0) {
      var mydivh = document.getElementById("mydiv")?.clientHeight;
      tableHeight = (mydivh * 96) / 100 - 200;
      if (dataHeight > tableHeight) {
        document.getElementById("tblbodydiv").style.width = "100%";
      } else {
        document.getElementById("tblbodydiv").style.width = "calc(100% - 16px)";
      }
    }
  } catch (e) {
    isLoading.value = false;
  }
}

watch(
  () => store.getters.stationListData,
  function () {
    if(store.getters.stationListData != null && isPageLoad){
      stationCodeListInfo.splice(0);
      stationCodeListInfo.push(store.getters.stationListData);
      isLoading.value = false;
      isPageLoad.value = false;
    }else{
      isLoading.value = true;
    }
  }
);

const rowParam = (param) => {
  modalStationCode.value = param;
};

/** Delete StationCode List */
const deleteStationCode = (param) => {
  isLoading.value = true;
  alertMessage.value = "null";
  alertState.value = "neutral";
  const data = { stationCode: param };

  StationDataService.checkStationInUse(data)
    .then((response: ResponseData) => {
      // StationCodeは「User」テーブルに利用中場合、
      if (response.data.userCount !== 0) {
        alert(i18n.t("alt062"));
        isLoading.value = false;
        return;
      }
      // StationCodeは「PcCompanyMaster」テーブルに利用中場合、
      if (response.data.pcMasterCount !== 0) {
        alert(i18n.t("alt063"));
        isLoading.value = false;
        return;
      }
      // StationCodeは「tmpUser」テーブルに利用中場合、
      if (response.data.tempUserCount !== 0) {
        alert(i18n.t("alt064"));
        isLoading.value = false;
        return;
      }
      StationDataService.deleteStationCodeData(param)
        .then((_) => {
          var stationList = []
          for(let stObj of store.getters.stationListData){
            if(stObj.stationCode != param){
              stationList.push(stObj);
            }
          }
          store.dispatch("setStationListData", stationList);
          alertMessage.value = i18n.t("suc027");
          alertState.value = "success";
          isLoading.value = false;
        })
        .catch((e: Error) => {
          console.log(e);
          alertMessage.value = i18n.t("err054");
          alertState.value = "error";
          isLoading.value = false;
        });
      isLoading.value = false;
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err053");
      alertState.value = "error";
      isLoading.value = false;
    });
};

onUpdated(function () {
  handleResize();
});

const clearModalData = () => {
  modalStationCode.value = "";
};

const addStationCode = () => {
  store.dispatch("setShowPage", "StationCodeRegistration");
  store.dispatch("setStatus", "");
};

const editStationCode = (stationCode, companyName, digit3, parentCode, countryCode, areaCode) => {
  var editData = {
    stationCode: stationCode,
    companyName: companyName,
    threeDigitCode: digit3,
    parentCode: parentCode,
    countryCode: countryCode,
    areaCode: areaCode
  }
  store.dispatch("setEditSationData", editData);
  store.dispatch("setShowPage", "StationCodeRegistration");
  store.dispatch("setStatus", "Edit");
};

const __returned__ = { isLoading, alertMessage, alertState, i18n, title, stationCodeListInfo, modalStationCode, getData, isPageLoad, handleResize, rowParam, deleteStationCode, clearModalData, addStationCode, editStationCode, AdminNavigation, Loading, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})